import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-loanmgmt-bbc',
  templateUrl: './ll-loanmgmt-bbc.component.html',
  styleUrls: ['./ll-loanmgmt-bbc.component.css']
})
export class LlLoanmgmtBBCComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_loanmgmt_bbc') private mainDiv: ElementRef;

  constructor(private llModelsService: LlModelsService) { }

  bundle = {
    showObj: false,
    function:'',
    spB: 0,
    objW: 0,
    objH: 0,
    editorX: 10,
    editorY: 30,
    editorW: 0,
    editorH: 0,
    REPORT_BODY: '',
    errorMessage: ''
  };

  ngOnInit() { }

  ngAfterViewInit() {
    this.setVars();
  }

  ngOnDestroy() {
    if (this.bundle.REPORT_BODY && typeof this.bundle.REPORT_BODY === 'string' && this.bundle.REPORT_BODY.startsWith('blob:')) {
      URL.revokeObjectURL(this.bundle.REPORT_BODY);
    }
  }

  setVars() {
    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;
    this.bundle.showObj = false;
    this.bundle.objW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.objH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;
    setTimeout(() => {
      this.bundle.editorW = this.bundle.objW - (this.bundle.editorX * 2);
      this.bundle.editorH = this.bundle.objH - this.bundle.editorY - 40;
      this.bundle.spB = this.bundle.editorY + this.bundle.editorH + 10;
      this.getData();
    });
  }

  getData() {
    this.llModelsService.NG_LL_model_AR_reports_loanMgmt_BBC_one(this.bundle.function, (pdf) => {
      try {
        if (!pdf) {
          this.bundle.errorMessage = 'No PDF data received from the service.';
          this.bundle.showObj = true;
          return;
        }

        if (typeof pdf === 'string' && /^[A-Za-z0-9+/=]+$/.test(pdf)) {
          console.log('Detected base64 string');
          this.bundle.REPORT_BODY = `data:application/pdf;base64,${pdf}#navpanes=0`;
        } else if (typeof pdf === 'string' && pdf.startsWith('http')) {
          console.log('Detected URL');
          this.bundle.REPORT_BODY = `${pdf}#navpanes=0`;
        } else if (pdf instanceof Blob) {
          console.log('Detected Blob');
          this.bundle.REPORT_BODY = `${URL.createObjectURL(pdf)}#navpanes=0`;
        } else {
          this.bundle.errorMessage = 'Invalid PDF data format received.';
          this.bundle.showObj = true;
          return;
        }

        this.bundle.showObj = true;
        this.bundle.errorMessage = '';
      } catch (error) {
        console.error('Error processing PDF:', error);
        this.bundle.errorMessage = 'Failed to load PDF: ' + error.message;
        this.bundle.showObj = true;
      }
    }, this.bundle);
  }

  onIframeError(event: Event) {
    console.error('Iframe failed to load:', event);
    this.bundle.errorMessage = 'Failed to display PDF. Please try again or contact support.';
    this.bundle.REPORT_BODY = '';
  }
}
